import * as React from 'react';

let index = 0;
function generateSafeId() {
  return `auic-${index++}`;
}

function useSafeId(id?: string) {
  const [safeId] = React.useState(() => generateSafeId());
  return id || safeId;
}

export { useSafeId };
